import { toYoutubeEmbedUrl } from '@/lib/media';

interface YoutubeEmbedProps {
  url: string;
  title?: string;
  className?: string;
}

function YoutubeEmbed({ url, title, className }: YoutubeEmbedProps) {
  const embedUrl = toYoutubeEmbedUrl(url);
  if (!embedUrl) return null;

  return (
    <iframe
      src={embedUrl}
      title={title || 'Vidéo YouTube'}
      className={className}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      referrerPolicy="strict-origin-when-cross-origin"
    />
  );
}

export default YoutubeEmbed;